import { throwResponseErrors } from '@module/mdrt-org/shared/utils/http-services/throw-response-errors';

import { InternalServerError } from './error-definitions';

export const fetchWithErrorHandling = async <T>(
  apiUrl: Request | string | URL,
  { cache, next, ...rest }: RequestInit
): Promise<T> => {
  const response = await fetch(apiUrl, {
    ...rest,
    cache:
      next?.revalidate === undefined ? (cache === undefined ? 'force-cache' : cache) : undefined,
  });

  const contentType = response.headers.get('content-type');

  if (response.ok && contentType && contentType.includes('application/json')) {
    return await response.json();
  }

  await throwResponseErrors(response);
  // This line is unreachable, but required for type safety
  throw new InternalServerError();
};
